/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React from 'react';
import { IDobbiesMaintenanceViewProps } from './dobbies-maintenance';

export default (props: IDobbiesMaintenanceViewProps) => {
    const { maintenanceBlockContainer, text, logo, overlay, background } = props;
    return (
        <Module {...maintenanceBlockContainer}>
            {background && <Node {...background} />}
            <Node {...overlay}>
                {logo}
                {text}
            </Node>
        </Module>
    );
};
